module.exports = __webpack_public_path__ + "static/media/산업재산권.91707664.png";